(function (angular) {
    'use strict';

    // id: Identificador de la página estática. (Nombre del archivo o identificador de BD).
    // carpeta: Ruta a la página en caso de que haya alguna carpeta intermedia.
    // bd: Boolean. Si se obtiene de BD, se carga el archivo estatica.html y se muestra el contenido.
    // sinTitulo: Boolean. Si es true, el título de la sección se ocultará.

    angular
        .module('app')
        .component('estatica', {
            bindings: {
                id: '@', // required
                carpeta: '@',
                bd: '<',
                sinTitulo: '<',
                clase: '@'
            },
            /* @ngInject */
            templateUrl: function ($element, $attrs, Language) {
                if ($attrs.bd === "true") {
                    return 'app/components/estaticas/estatica.html';
                } else {
                    var carpeta = "";
                    if ($attrs.carpeta) {
                        carpeta = $attrs.carpeta + "/";
                    }
                    return 'estaticas/' + carpeta + $attrs.id + '/' + $attrs.id + '.' + Language.getCurrent() + '.html';
                }
            },
            /* @ngInject */
            controller: function (Estatica, Language) {
                var vm = this;
                if (vm.bd) {
                    Estatica.getByNombreIdioma({
                        'nombre': vm.id,
                        'idioma': Language.getCurrent()
                    }).$promise.then(function (data) {
                        vm.estaticai18n = data;
                    });
                }
            },
            controllerAs: 'ctrl'
        });
})(angular);
